import React from 'react'
import { dishes } from '../const/dishes'
import About from '../components/About'
import AboutTwo from '../components/AboutTwo'
import Pricing from '../components/Pricing'

const CourseListing = () => {
    return (
        <>
            <div className="bg-[#fff] min-h-[100vh]">
                <div className='relative flex justify-center items-center h-16 bg-[#fff] text-white   overflow-hidden min-h-[600px] min-w-[100vw]'>

                    <div className='absolute top-0 z-10 bg-gradient-to-b from-[#111] via-black-900 to-transparent w-full h-[200px] opacity-50'>
                    </div>
                    <img src="/images/1.jpg" className='w-[100%] h-[100%]  object-fit ' />
                    <div className='absolute bottom-0 z-10 bg-gradient-to-t from-[#fff] via-gray-200 to-transparent w-full h-[400px] opacity-100'>
                    </div>
                    <div className='absolute bottom-0 z-20 flex flex-col  text-left min-h-[100px] w-full px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-6'>
                        <div className='text-white text-xs rounded-full bg-[#111111ab] px-4 p-2 mb-2 w-fit'>
                            Certified
                        </div>
                        <p className='text-4xl text-black font-bold mb-2'>Online Workout Lessions</p>
                        <p className='text-gray-900'> Premium Classes by top coaches</p>
                    </div>
                </div>
                <div className="mx-auto max-w-2xl px-4 pb-16 pt-0 sm:px-6 sm:py-6 lg:max-w-7xl lg:px-8">

                    <h2 className="text-2xl font-bold tracking-tight text-gray-900 mb-4">
                        GREAT FITNESS BEGINS WITH GREAT MENTORSHIP
                    </h2>
                    <p>
                        Train online with FitMasters Academy and Pro Trainer Hub — two of the most trusted names in workout development and fitness instruction. Now you can access top workout programs and expert trainers to become the best version of yourself. Start your 3-Week FREE trial today to gain access to the best online fitness classes for serious fitness enthusiasts.
                    </p>
                    <h2 className="text-2xl font-bold tracking-tight text-gray-900 mt-12">
                        Get Unlimited Access to 320+ Online Courses
                    </h2>

                    <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
                        {
                            dishes.map((product) => (
                                <div key={product.id} className="group relative">
                                    <img
                                        alt={product.imageAlt}
                                        src={product.imageSrc}
                                        className="aspect-square w-full rounded-md bg-gray-200 object-cover group-hover:opacity-75 lg:aspect-auto lg:h-80"
                                    />
                                    <div className="mt-4 flex justify-center">
                                        <div>
                                            <h3 className="text-sm font-bold text-center text-gray-900 w-full">
                                                <a href={product.href + product.id} className="hover:text-gray-900">
                                                    <span aria-hidden="true" className="absolute inset-0" />
                                                    {product.name}
                                                </a>
                                            </h3>
                                        </div>
                                    </div>
                                    {/* <div>
                                    <button className="mt-6 bg-[#00925D] w-fit px-6 text-white text-sm font-medium rounded-md py-2">Add</button>
                                </div> */}
                                </div>
                            ))
                        }
                    </div>
                    <About />
                    <AboutTwo />
                    <Pricing />
                </div>
            </div>
        </>
    )
}

export default CourseListing

